/* eslint-disable new-parens */
import React from "react";
import { FileText, ImageOff, Trophy } from "lucide-react";
import { hasBulandiEventRulesPng } from "../../../utils/bulandiEventRulesPng";
import { hasBulandiEventWinnersPng } from "../../../utils/bulandiEventWinnersPng";
import {
  PRIZES_TBA_PHRASE,
  stripHashLeadCopy,
  eventIconWrapCls,
  eventIconImgCls,
  eventIconPhCls,
} from "./eventCatalogUtils";
import { EventScheduleBadge } from "./EventScheduleBadge";

export function EventCard({ event, onViewRules }) {
  const tier = event.ageTier || "seniors";
  const blurb = stripHashLeadCopy(event.shortDescription);
  const showPrizes =
    event.prizes && !PRIZES_TBA_PHRASE.test(String(event.prizes).trim());
  const hasRules = hasBulandiEventRulesPng(event);
  const hasWinners = hasBulandiEventWinnersPng(event);
  return React.createElement(
    "li",
    {
      className:
        "group relative flex flex-col overflow-hidden rounded-2xl border-2 border-bul-border bg-bul-surface/90 shadow-bul-brutal-sm transition hover:-translate-y-0.5 hover:border-bul-lime/50",
    },
    React.createElement(
      "div",
      { className: "p-4 sm:p-5" },
      React.createElement(
        "div",
        {
          className:
            "flex min-w-0 flex-wrap items-start gap-2.5 sm:items-start sm:justify-between sm:gap-3",
        },
        React.createElement(
          "div",
          { className: eventIconWrapCls() },
          event.imageUrl
            ? React.createElement("img", {
                src: event.imageUrl,
                alt: event.name,
                className: eventIconImgCls(tier),
                loading: "lazy",
                decoding: "async",
              })
            : React.createElement(
                "div",
                { className: eventIconPhCls(tier) },
                React.createElement(ImageOff, {
                  className: "h-9 w-9 sm:h-11 sm:w-11 md:h-12 md:w-12",
                  "aria-hidden": true,
                }),
              ),
        ),
        React.createElement(EventScheduleBadge, { eventId: event.id }),
      ),
      React.createElement(
        "div",
        { className: "mt-3 flex min-w-0 flex-col gap-2.5 sm:mt-4 sm:gap-3" },
        React.createElement(
          "div",
          null,
          React.createElement(
            "h3",
            {
              className:
                "break-words font-display text-[0.84375rem] uppercase leading-snug tracking-tight text-bul-fg sm:text-[0.9375rem] sm:leading-tight",
            },
            event.name,
          ),
        ),
        blurb
          ? React.createElement(
              "p",
              {
                className:
                  "break-words text-sm leading-relaxed text-bul-mutedfg md:line-clamp-3",
              },
              blurb,
            )
          : null,
        showPrizes
          ? React.createElement(
              "p",
              {
                className:
                  "break-words font-mono text-xs font-bold uppercase tracking-wider text-bul-lime",
              },
              React.createElement("span", { "aria-hidden": true }, "\uD83C\uDFC6"),
              " ",
              event.prizes,
            )
          : null,
        React.createElement(
          "div",
          { className: "mt-auto pt-1 sm:pt-2" },
          hasWinners
            ? React.createElement(
                "button",
                {
                  type: "button",
                  onClick: () => onViewRules?.(event),
                  className:
                    "flex w-full min-h-[38px] items-center justify-center gap-2 rounded-xl border-2 border-bul-border bg-bul-bg/50 px-3 py-2.5 text-center font-mono text-[11px] font-bold uppercase leading-snug tracking-[0.04em] text-bul-lime transition hover:border-bul-lime/50 hover:bg-bul-lime/10 sm:min-h-[40px] sm:px-4 sm:text-xs sm:tracking-[0.06em]",
                },
                React.createElement(Trophy, {
                  className: "h-4 w-4 shrink-0",
                  "aria-hidden": true,
                  strokeWidth: 2.5,
                }),
                "View winners",
              )
            : hasRules
            ? React.createElement(
                "button",
                {
                  type: "button",
                  onClick: () => onViewRules?.(event),
                  className:
                    "flex w-full min-h-[38px] items-center justify-center gap-2 rounded-xl border-2 border-bul-border bg-bul-bg/50 px-3 py-2.5 text-center font-mono text-[11px] font-bold uppercase leading-snug tracking-[0.04em] text-bul-lime transition hover:border-bul-lime/50 hover:bg-bul-lime/10 sm:min-h-[40px] sm:px-4 sm:text-xs sm:tracking-[0.06em]",
                },
                React.createElement(FileText, {
                  className: "h-4 w-4 shrink-0",
                  "aria-hidden": true,
                  strokeWidth: 2.5,
                }),
                "View rules",
              )
            : React.createElement(
                "span",
                {
                  className:
                    "flex w-full min-h-[38px] items-center justify-center rounded-xl border-2 border-dashed border-bul-border bg-bul-bg/50 px-3 py-2.5 text-center font-mono text-[11px] font-bold uppercase leading-snug tracking-[0.04em] text-bul-mutedfg whitespace-normal sm:min-h-[40px] sm:px-4 sm:text-xs sm:tracking-[0.06em]",
                  role: "status",
                },
                "Rules \u2014 coming soon",
              ),
        ),
      ),
    ),
  );
}
